import React, { useEffect, useState } from 'react';
import './index.scss';
import '../../custom.js';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Modal,
    Input,Switch, Upload, Spin, Select, Skeleton,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';

 import ReactQuill, { Quill } from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { fillEn } from 'client/src/methods/forms';
import imgIcon from '../../../src/img/image-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import deFlag from '../../../src/img/de-icon.png';
import enFlag from '../../../src/img/en-icon.png';
import TextArea from 'antd/lib/input/TextArea';
import vDOts from '../../../src/img/v-dots.png';
import '../../custom.js';
import Parameters from 'shared/parameters';
import moment from 'moment';

interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
export default function BannerForm(props: Props) {
    const [deletingItem, setDeletingItem] = useState(false);
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [lang, setLang] = useState('' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchBannerById(RouteParams['id']);
            setItem({
                ...data,
            });
            //console.log(RouteParams['id'])
            setImage({ image: getImageUrl(data.media), imageId: data.media_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        setLang(localStorage.getItem('language'));
    }, []);

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className={'d-flex justify-space-between mb-3'}>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className={lang == 'ar' ? '' : 'mr-4'}>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div className={lang == 'ar' ? 'ml-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('banner.create') : ''}</h3></div>
                        <div className={lang == 'ar' ? 'ml-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'view' ? t('banner.profile') : ''}</h3></div>
                        <div className={lang == 'ar' ? 'ml-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'edit' ? t('banner.edit') : ''}</h3></div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                    {RouteParams['mode'] === 'create' || RouteParams['mode'] === 'edit' ?
                        <div className='bg-white p-3 br-5px'>
                            <div className="row">
                            <div className="col-md-12 pt-3 pb-3">
                                <div className="form-fields pl-4 pr-6rem">
                                    <fieldset>
                                        <Form
                                        size="large"
                                        form={form}
                                        initialValues={item}
                                        fields={[]}
                                        onFinish={(value) => {
                                            
                                            value.status = (value.status === true) ? 1 : 0;

                                            // console.log(value);
                                            //  return;
                                            if (!image.imageId) {
                                                notification.error({ message: t('image.required') });
                                                return;
                                            }
                                            const reqObj: any = value;
                                            reqObj['media_id'] = image.imageId;
                                            setSaving(true);
                                            if (item && item.id) {
                                                API_SERVICE.updateBanner(item.id, reqObj).then((d) => {
                                                    history.push(`/banners/`);
                                                }).catch((e) => {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    setSaving(false);
                                                });
                                            } else {
                                                API_SERVICE.createBanner(reqObj).then((d) => {
                                                    history.goBack();
                                                }).catch((e) => {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    setSaving(false);
                                                });
                                            }
                                        }}
                                        layout="vertical"
                                        requiredMark={true}
                                        >
                                        <div className={lang === 'ar' ? 'row text-right' : 'row'}>
                                            <div className="col-md-5">
                
                                                <h5 >{t('genDict.uploadBanner')}</h5>
                                                <p className="text-secondary">{t('genDict.uploadBannerParagraph')}</p>
                                            </div>
                                            <div className="col-md-7">
                                                <div className="form-group">
                                                {
                                                    uploading ? <Spin/> : (
                                                        image.image ? <div>
                                                            
                                                            <div className="d-flex align-items-center">
                                                                <div className="uploadeImgBg mr-2">
                                                                    <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                                </div>
                                                                <div>
                                                                    {
                                                                        RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                                            image: null,
                                                                            imageId: null,
                                                                        })}>{t('genDict.remove')}</Button>
                                                                        
                                                                    }
                                                                </div>
                                                            </div>
                                                            
                                                        </div> : <Upload beforeUpload={(file) => {
                                                                    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                                        notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                                    }
                                                                        uploadImage(file);
                                                                        return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                                    }}>
                                                                    <div className={lang === 'ar' ? 'd-flex align-items-center gap-2': 'd-flex align-items-center'}>
                                                                        <div className="mr-2">
                                                                                <img src={imgIcon} className="logo-org"/>
                                                                            {/* <i className="fa fa-picture-o logo-org"></i> */}
                                                                            {/* <img src="#" id="orgLogo" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/> */}
                                                                        </div>
                                                                        <div>
                                                                            <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                                        </div>
                                                                    </div>
                                                                </Upload>
                                                    )
                                                }
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        </hr>
                                        <div className={lang === 'ar' ? 'row text-right' : 'row'}>
                                            <div className="col-md-5 mt-4">
                                                <h5>{t('genDict.bannerInformation')}</h5>
                                                
                                                <p className="text-secondary">{t('genDict.bannerInformatioParagraph')}</p>
                                            </div>
                                            <div className="col-md-7 mt-4">
                                                <Form.Item
                                                    label={t('title.label')}
                                                    name={['title', selectedLang]}
                                                    rules={[
                                                        { required: true, message: t('title.required') },
                                                    ]}
                                                >
                                                    <Input className="form-control" disabled={RouteParams['mode'] === 'view'}/>
                                                </Form.Item>
                                                {/* <Form.Item
                                                    label={t('banner.title.label')}
                                                    name={['title', 'en']}
                                                    rules={[]}>
                                                    <Input className="form-control" disabled={RouteParams['mode'] === 'view'}/>
                                                </Form.Item> */}
                                                
                                                    {/* <Form.Item
                                                        initialValue={item? item.description.de:''}
                                                        label={t('banner.descriptionDe.label')}
                                                        name={['description', 'de']}
                                                        rules={[
                                                            { required: true, message: t('banner.descriptionDe.required') },
                                                        ]}
                                                    >
                                                        {RouteParams['mode'] === 'view'?
                                                        <Input className="form-control" disabled/>
                                                        :<TextArea className="form-control" rows={4} />
                                                        }
                                                    </Form.Item> */}
                                                
                                                    <Form.Item
                                                        // initialValue={item? item.description.en:''}
                                                        label={t('description.label')}
                                                        name={['description', selectedLang]}
                                                        rules={[
                                                            { required: true, message: t('description.required') },
                                                        ]}>
                                                        {RouteParams['mode'] === 'view'?
                                                        <Input className="form-control" disabled/>
                                                        :<TextArea className="form-control" rows={4} />
                                                        }
                                                    </Form.Item>  
                                                
                                            <Form.Item
                                            initialValue= {item? item.status: false}
                                            label={t('active.label')}  
                                            name={'status'}    
                                            rules={[]}>
                                            {RouteParams['mode'] === 'view'?
                                                <Switch disabled/>
                                                :<Switch/>
                                            }
                                            </Form.Item>                                  
                                            </div>
                                            </div>
                                        <hr></hr>
                                        
                                        {
                                            RouteParams['mode'] !== 'view' && <Form.Item>
                                                <Button                                 
                                                    htmlType="submit"
                                                    loading={saving || uploading}
                                                    size={'large'}
                                                    className="submit btn-blue float-right"
                                                >
                                                    {t('genDict.save')}
                                                </Button>
                                                <Button                                 
                                                    htmlType="reset"
                                                    size={'large'}
                                                    className="reset mr-3 btn-default float-right"
                                                >
                                                    {t('genDict.cancel')}
                                                </Button>
                                            </Form.Item>
                                        }
                                        </Form>
                                    </fieldset>
                                </div>
                            </div>
                            </div>
                        </div>
                        :''
                    }
                    {RouteParams['mode'] === 'view' ?
                        <div className='bg-white p-3 br-5px'>
                            <div className="row">
                            <div className="col-sm-6 pb-3">
                                <div className="d-flex align-items-center">
                                    <div className="">
                                        <img src={image.image} style={{width:'200px'}}/>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-sm-6 pb-3 text-sm-right">
                                <span className="text-secondary mr-4">{moment(item?.created_at).format('DD MMMM, YYYY')}</span>
                                <span className="dropdown">
                                    <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                        <img src={vDOts} style={{width: '25px'}} />
                                    </a>
                                    <div className="dropdown-menu">
                                    <a className="dropdown-item" role="button"
                                        onClick={() => {
                                            history.push(`/banners/${item.id}/edit`);
                                        }}
                                    > {t('genDict.Edit')}</a>
                                    <a className="dropdown-item" role="button"
                                    onClick={() => confirm({
                                        icon: <ExclamationCircleOutlined/>,
                                        title: t('genDict.confirmDelete'),
                                        okText: t('genDict.ok'),
                                        cancelText: t('genDict.cancel'),
                                        content: `${t('genDict.confirmDelete')} "${item.title.en}"`,
                                        okButtonProps: { loading: deletingItem, danger: true },
                                        onOk: async () => {
                                            setDeletingItem(true);
                                            API_SERVICE.removeBanner(item.id).then((d) => {
                                                notification.success({
                                                    message: t('genDict.success'),
                                                });
                                                // refreshItems();
                                                history.push(`/banners/`);
                                            }).catch((e: any) => {
                                                notification.error({
                                                    message: t(API_SERVICE.handleErrors(e)),
                                                });
                                            }).finally(() => {
                                                setDeletingItem(false);
                                            });
                                        },
                                    })
                                }
                                    >{t('genDict.delete')}</a>
                                    </div>
                                </span>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-md-12 pb-3">
                                <div className="table-responsive mt-2">
                                    <table className="table course-details-table box-shadow">
                                        
                                        <tbody>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.title')}</td>
                                            <td>
                                                {
                                                    Parameters.DefaultLang === 'de' ? item.title.de : ''
                                                }
                                                {
                                                    Parameters.DefaultLang === 'en' ? item.title.en : ''
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.description')}</td>
                                            <td>
                                                {
                                                    Parameters.DefaultLang === 'de' ? item.description.de : ''
                                                }
                                                {
                                                    Parameters.DefaultLang === 'en' ? item.description.en : ''
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.Active')}</td>
                                            <td>
                                                {
                                                    item.status === 'ACTIVE' ? 'YES' : 'No'
                                                }
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                        </div>
                    :''
                    }
                    </div>
                </div>
            </div>
        </div>
    );
}
